module.exports = __webpack_public_path__ + "img/walletconnect.37f2bc6e.svg";